import React from 'react'
import Modal from '@lwt-helix/modal'
import { useAuthStore } from '../../store/auth/store';
import { modalTerms, modalTitles } from '../../constants';
import { LinkLwaModalButtons } from './LinkLwaModalButtons';

export const LinkLwaModal = () => {
    const {
        errorLinkingLwa,
        shouldShowLinkLwaModal,
    } = useAuthStore(state => ({
        errorLinkingLwa: state.errorLinkingLwa,
        shouldShowLinkLwaModal: state.shouldShowLinkLwaModal,
    }));

    return (
        <Modal
            show={shouldShowLinkLwaModal}
            title={modalTitles.linkLwaModal}
            buttons={<LinkLwaModalButtons />}
        >
            <h6>{modalTerms.linkLwaModalsubtitle}</h6>
            <p className='text-modal-msg'>
                {modalTerms.linkLwaModalBody1}
                <br/>
                <br/>
                {modalTerms.linkLwaModalBody2}
            </p>
            {errorLinkingLwa && (
                <p className='text-danger text-center'>
                    <br/>
                    {errorLinkingLwa}
                </p>
            )}
        </Modal>
    );
};
